(function () {
  /* ── Sticky Add-To-Cart ── */
  function initStickyATC() {
    const buyBtn = document.querySelector('.product-form__submit');
    if (!buyBtn) return;

    const productTitle = document.querySelector('.product__title h1')?.textContent?.trim() || '';
    const productPrice = document.querySelector('.price-item--regular, .price-item--sale')?.textContent?.trim() || '';
    const productImg = document.querySelector('.product__media img')?.src?.replace(/width=\d+/, 'width=120') || '';

    const bar = document.createElement('div');
    bar.id = 'snsei-sticky-atc';
    bar.innerHTML = `
      ${productImg ? `<img id="snsei-sticky-atc__img" src="${productImg}" alt="${productTitle}">` : ''}
      <div id="snsei-sticky-atc__info">
        <div id="snsei-sticky-atc__title">${productTitle}</div>
        <div id="snsei-sticky-atc__price">${productPrice}</div>
      </div>
      <button id="snsei-sticky-atc__btn" type="button">הוסף לסל</button>
      <button id="snsei-sticky-atc__buy" type="button">קנה עכשיו</button>
    `;
    document.body.appendChild(bar);

    // Sync disabled state
    function syncState() {
      const atcBtn = document.getElementById('snsei-sticky-atc__btn');
      if (!atcBtn) return;
      atcBtn.disabled = buyBtn.disabled;
      atcBtn.textContent = buyBtn.disabled ? (buyBtn.textContent.trim() || 'אזל מהמלאי') : 'הוסף לסל';
      const stickyBuyBtn = document.getElementById('snsei-sticky-atc__buy');
      if (stickyBuyBtn) stickyBuyBtn.disabled = buyBtn.disabled;
    }
    syncState();
    new MutationObserver(syncState).observe(buyBtn, { attributes: true, childList: true, subtree: true });

    // Click → submit the real form
    document.getElementById('snsei-sticky-atc__btn').addEventListener('click', () => {
      buyBtn.click();
    });

    // «קנה עכשיו» מפעיל את ה-Buy It Now של שופיפיי (וריאנט+כמות נשמרים, העגלה לא נמחקת).
    // הכפתור של שופיפיי עובר hydration מאוחר, לכן מאתרים אותו בזמן הקליק ולא בטעינה.
    const stickyBuy = document.getElementById('snsei-sticky-atc__buy');
    if (!document.querySelector('.shopify-payment-button')) stickyBuy.style.display = 'none';
    stickyBuy.addEventListener('click', () => {
      const payBtn = document.querySelector('.shopify-payment-button button');
      if (payBtn && !payBtn.disabled) payBtn.click();
    });

    // Show/hide on scroll via IntersectionObserver
    const observer = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('visible', !entry.isIntersecting);
      // הכפתורים הצפים (נגישות, וואטסאפ) מקשיבים ל-class הזה כדי לעלות מעל הבר
      document.body.classList.toggle('snsei-atc-visible', !entry.isIntersecting);
    }, { threshold: 0 });
    observer.observe(buyBtn);
  }

  /* ── Free Shipping Progress Bar ── */
  const FREE_SHIPPING_THRESHOLD = 24900; // 249₪ in cents. הסף הקבוע בחנות (Shopify shipping profile), עודכן 19/08/2026

  function renderShippingBar() {
    const footer = document.querySelector('.cart-drawer__footer, .cart__footer');
    if (!footer || document.getElementById('snsei-shipping-bar')) return;

    const bar = document.createElement('div');
    bar.id = 'snsei-shipping-bar';
    footer.parentNode.insertBefore(bar, footer);
    updateShippingBar();
  }

  function updateShippingBar() {
    const bar = document.getElementById('snsei-shipping-bar');
    if (!bar) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const total = cart.total_price;
        const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - total);
        const pct = Math.min(100, Math.round((total / FREE_SHIPPING_THRESHOLD) * 100));
        const remainingFormatted = (remaining / 100).toFixed(0);

        if (remaining === 0) {
          bar.innerHTML = `<p><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polyline points="20 6 9 17 4 12"/></svg> <strong>קיבלת משלוח חינם!</strong></p>
            <div id="snsei-shipping-bar__track"><div id="snsei-shipping-bar__fill" style="width:100%"></div></div>`;
        } else {
          bar.innerHTML = `<p>עוד <strong>${remainingFormatted}₪</strong> לקבלת משלוח חינם</p>
            <div id="snsei-shipping-bar__track"><div id="snsei-shipping-bar__fill" style="width:${pct}%"></div></div>`;
        }
      });
  }

  // Re-render whenever cart drawer opens or cart updates
  document.addEventListener('shopify:section:load', renderShippingBar);
  document.addEventListener('cart:refresh', updateShippingBar);

  // MutationObserver on cart drawer open
  const drawerObserver = new MutationObserver(() => {
    if (document.querySelector('cart-drawer.active, cart-drawer[open]')) {
      renderShippingBar();
      updateShippingBar();
    }
  });
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) drawerObserver.observe(cartDrawer, { attributes: true });

  // Also watch for cart-drawer becoming open via class changes
  document.addEventListener('click', (e) => {
    if (e.target.closest('[href="/cart"], .header__icon--cart, [data-action="open-cart"]')) {
      setTimeout(() => { renderShippingBar(); updateShippingBar(); }, 300);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initStickyATC();
      renderShippingBar();
    });
  } else {
    initStickyATC();
    renderShippingBar();
  }
})();

